/* =========================================================================
   My Prolearning — Cart page
   AJAX quantity / remove via the Section Rendering API (no full reload),
   reveal animations, discount-code field. Header cart drawer/count refresh
   is handled by mpl-chrome.js (window.MPLChrome).
   ========================================================================= */
(function () {
  "use strict";

  function root() { return document.querySelector("[data-mpl-cart]"); }
  function sectionId() { var r = root(); return r ? r.getAttribute("data-section-id") : null; }

  /* ---- reveal ---- */
  function reveal(animate) {
    var els = document.querySelectorAll(".mpl-cart-rv");
    if (!animate || window.matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) {
      [].forEach.call(els, function (e) { e.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var sibs = [].slice.call(en.target.parentElement.children).filter(function (c) { return c.classList.contains("mpl-cart-rv"); });
        en.target.style.transitionDelay = (Math.max(0, sibs.indexOf(en.target)) * 60) + "ms";
        en.target.classList.add("in");
        io.unobserve(en.target);
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -6% 0px" });
    [].forEach.call(els, function (e) { io.observe(e); });
  }

  /* ---- AJAX cart change via Section Rendering ---- */
  function changeCart(key, qty) {
    var id = sectionId();
    var body = { id: key, quantity: qty };
    if (id) { body.sections = id; body.sections_url = window.location.pathname; }
    var r = root(); if (r) r.style.opacity = ".6";
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (state) {
        var html = state.sections && id ? state.sections[id] : null;
        if (html) {
          var wrap = document.getElementById("shopify-section-" + id);
          if (wrap) { wrap.innerHTML = html; }
        }
        reveal(false);              /* show instantly after an update */
        if (window.MPLChrome && window.MPLChrome.refresh) { window.MPLChrome.refresh(); }
        var rr = root(); if (rr) rr.style.opacity = "";
      })
      .catch(function () { window.location.reload(); });
  }

  /* ---- delegated actions ---- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-mpl-cart] [data-action]");
    if (!btn) return;
    var act = btn.getAttribute("data-action");
    var key = btn.getAttribute("data-key");
    if (!key) return;
    var line = btn.closest(".mpl-cart-line");
    if (act === "remove") {
      if (line) { line.classList.add("removing"); setTimeout(function () { changeCart(key, 0); }, 240); }
      else { changeCart(key, 0); }
    } else if (act === "inc" || act === "dec") {
      var input = line ? line.querySelector(".mpl-cart-line__q") : null;
      var cur = input ? (parseInt(input.value, 10) || 0) : 1;
      var next = act === "inc" ? cur + 1 : Math.max(0, cur - 1);
      var tot = line ? line.querySelector(".mpl-cart-line__total") : null;
      if (tot) { tot.classList.remove("bump"); void tot.offsetWidth; tot.classList.add("bump"); }
      changeCart(key, next);
    }
  });

  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-mpl-cart] .mpl-cart-line__q");
    if (!input) return;
    var key = input.getAttribute("data-key");
    var q = Math.max(0, parseInt(input.value, 10) || 0);
    changeCart(key, q);
  });

  /* ---- discount code ---- */
  document.addEventListener("click", function (e) {
    if (!e.target.closest("#mplPromoApply")) return;
    var field = document.getElementById("mplPromoCode");
    var code = field && field.value ? field.value.trim() : "";
    if (code) window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=/cart";
  });

  reveal(true);
})();
